import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Eye, Lock, Database, UserX, Mail } from 'lucide-react';
import { Button } from '../components/Button';
import { Card } from '../components/Card';
import { BottomNav } from '../components/BottomNav';
export function PrivacyPage() {
  const navigate = useNavigate();
  const sections = [{
    icon: Database,
    title: 'Data Collection',
    description: 'We collect only essential data: email, name, goals, and usage statistics to provide our service.'
  }, {
    icon: Lock,
    title: 'Data Security',
    description: 'Your data is encrypted and stored securely using industry-standard Firebase security.'
  }, {
    icon: Eye,
    title: 'Data Usage',
    description: 'We use your data solely to provide and improve the FlowQuest app experience. We never sell your data.'
  }, {
    icon: UserX,
    title: 'Account Deletion',
    description: 'You can delete your account and all associated data at any time from your profile settings.'
  }, {
    icon: Mail,
    title: 'Communications',
    description: "We only send notifications you've opted into. You can disable them anytime in settings."
  }];
  return <div className="min-h-screen bg-game-bg-pink dark:bg-[#1a1d29] pb-24" data-id="element-1087">
      <header className="px-6 pt-6 pb-4 sticky top-0 bg-game-bg-pink/90 dark:bg-[#1a1d29]/90 backdrop-blur-sm z-10" data-id="element-1088">
        <div className="flex items-center gap-4 mb-4" data-id="element-1089">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="!p-2" data-id="element-1090">
            <ArrowLeft className="w-6 h-6" data-id="element-1091" />
          </Button>
          <div data-id="element-1092">
            <h1 className="text-2xl font-fredoka font-bold text-game-dark dark:text-white" data-id="element-1093">
              Privacy & Security
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400 font-quicksand" data-id="element-1094">
              How we protect your data
            </p>
          </div>
        </div>
      </header>

      <main className="px-6 space-y-6 max-w-2xl mx-auto" data-id="element-1095">
        <Card className="p-6 bg-gradient-to-br from-purple-50 to-blue-50 dark:from-purple-900/20 dark:to-blue-900/20 border-purple-200 dark:border-purple-800" data-id="element-1096">
          <div className="flex items-start gap-4" data-id="element-1097">
            <div className="w-12 h-12 bg-purple-500 rounded-2xl flex items-center justify-center flex-shrink-0" data-id="element-1098">
              <Shield className="w-6 h-6 text-white" data-id="element-1099" />
            </div>
            <div data-id="element-1100">
              <h2 className="font-fredoka font-bold text-purple-900 dark:text-purple-100 text-lg mb-2" data-id="element-1101">
                Your Privacy Matters
              </h2>
              <p className="text-purple-800 dark:text-purple-200 font-quicksand text-sm leading-relaxed" data-id="element-1102">
                FlowQuest is committed to protecting your privacy. We believe in
                transparency and giving you control over your data.
              </p>
            </div>
          </div>
        </Card>

        <div className="space-y-4" data-id="element-1103">
          {sections.map(section => {
          const Icon = section.icon;
          return <Card key={section.title} className="p-5" data-id="element-1104">
                <div className="flex items-start gap-4" data-id="element-1105">
                  <div className="w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-1106">
                    <Icon className="w-5 h-5 text-game-purple" data-id="element-1107" />
                  </div>
                  <div className="flex-1" data-id="element-1108">
                    <h3 className="font-fredoka font-bold text-game-dark dark:text-white mb-1" data-id="element-1109">
                      {section.title}
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 font-quicksand text-sm leading-relaxed" data-id="element-1110">
                      {section.description}
                    </p>
                  </div>
                </div>
              </Card>;
        })}
        </div>

        <Card className="p-6" data-id="element-1111">
          <h3 className="font-fredoka font-bold text-game-dark dark:text-white mb-4" data-id="element-1112">
            Your Rights
          </h3>
          <ul className="space-y-3" data-id="element-1113">
            {['Access your data at any time', 'Export your data in a portable format', 'Request data correction or deletion', 'Opt out of non-essential communications', 'Control your privacy settings'].map((right, i) => <li key={i} className="flex items-start gap-3 text-gray-600 dark:text-gray-400 font-quicksand text-sm" data-id="element-1114">
                <div className="w-5 h-5 bg-game-teal rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1115">
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1116">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-1117" />
                  </svg>
                </div>
                {right}
              </li>)}
          </ul>
        </Card>

        <Card className="p-6 bg-gray-50 dark:bg-gray-800/50" data-id="element-1118">
          <p className="text-gray-600 dark:text-gray-400 font-quicksand text-sm text-center" data-id="element-1119">
            Last updated: {new Date().toLocaleDateString()}
          </p>
          <p className="text-gray-500 dark:text-gray-500 font-quicksand text-xs text-center mt-2" data-id="element-1120">
            Questions? Contact us at privacy@flowquest.app
          </p>
        </Card>
      </main>

      <BottomNav data-id="element-1121" />
    </div>;
}